// extracted by mini-css-extract-plugin
export default {"root":"ItemsGrid_root__Vydrg","container":"ItemsGrid_container__J0TIH","cell":"ItemsGrid_cell__YkmjN"};